import React, { useState, useEffect } from 'react';
// import './FAQ.css'; // Import your CSS file

const FAQ = () => {
  const faqData = [
    {
      question: 'What is the average time to source?',
      answer: '1-3 days for sourcing junior/mid-level vacancies, 5-7 days for headhunting and attracting mid-level/executive vacancies. 5-7 days for sourcing brokered and outsourced employees',
    },
    {
      question: 'What is the cost of a bad hire?',
      answer: 'Our guarantee period per placements is 3 months. This means if a placement falls during this period, we replace them at no additoinal cost to you',
    },
    {
        question: 'What tools/checks do you undertake to evaluate candidates?',
        answer: 'We do qualification, reference, ITC checks, criminal checks (require fingerprint). We also offer psychometric, personality and competency tests at an additional cost.',
    },
      {
        question: "What is your turnaround time? ",
        answer: "Our lead period ranges depending on the placement specification but may be as little as three (3) full workdays to source candidates suited to your needs. We also have the capacity to assist with emergency, same-day temporary placements should the need arise."
      },
      {
        question: "Do you carry out any verification tests?",
        answer: "Our verifications and tests range from Background, Qualification, Skills and Psychometric tests."
      },
      {
          question: "What are your fees?",
          answer: "The fees payable in respect of the placement will be calculated according to the annual cost to company (CTC) package of the placement. The total cost to company is deemed to be the basic salary plus any guaranteed benefits, e.g., 13th Cheque and Car Allowance. No deemed costs e.g., fuel, maintenance and living out-allowances, will be included in the CTC for calculation of the placement fee."
      }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % faqData.length);
  };

  useEffect(() => {
    const interval = setInterval(nextSlide, 5000);
    return () => clearInterval(interval);
  }, []);

  const moveToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="carousel-container">
      <div className="carousel-track">
        {faqData.map((faq, index) => (
          <div
            key={index}
            className={`faq-question-wrapper ${index === currentIndex ? 'active' : ''}`}
          >
            <p className="faq-question">{faq.question}</p>
            <p className="faq-answer">{faq.answer}</p>
          </div>
        ))}
      </div>
      <div className="carousel-trackers">
        {faqData.map((_, index) => (
          <div
            key={index}
            className={`carousel-tracker ${index === currentIndex ? 'active' : ''}`}
            onClick={() => moveToSlide(index)}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
